import type { Error } from '../types';

// All rework comments related to implicit any comparison string to numbers with triple equal e.t.c.
// Also don't repeat yourself use helper functions to extract common functionality.
// TODO: rework
export const minNumber =
  (min: number, message?: Error['message'], allowEmpty = false, allowDecimals = false) =>
  (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any
  ): Error => {
    const valid =
      (!!value || value === 0) && allowDecimals
        ? parseFloat(value) >= min
        : parseInt(value, 10) >= min;

    return {
      valid: allowEmpty ? isNaN(value) || valid : valid,
      message
    };
  };
